import React from "react";

const DeleteChatbotOffering = ({ onDelete, chatbotOffering }) => {
  if (!chatbotOffering) return null;

  return (
    <div className="border rounded p-4 space-y-4 bg-white shadow">
      <h2 className="text-xl font-bold text-red-600">Confirm Delete</h2>

      <div className="space-y-2">
        <p><strong>Offer:</strong> {chatbotOffering.offer}</p>
        <p><strong>Brand:</strong> {chatbotOffering.brand}</p>
        <p><strong>Preference:</strong> {chatbotOffering.preference}</p>
        <p><strong>Categories:</strong> {chatbotOffering.categories || chatbotOffering.category_ids.join(", ")}</p>
        <p><strong>Countries:</strong> {chatbotOffering.countries || chatbotOffering.country_ids.join(", ")}</p>
        <p><strong>Tier:</strong> {chatbotOffering.tier || "N/A"}</p>
        <p><strong>Priority:</strong> {chatbotOffering.priority}</p>
        <p><strong>Creative Media:</strong> <a href={chatbotOffering.creative_media} target="_blank" rel="noreferrer">{chatbotOffering.creative_media}</a></p>
        <p><strong>Detail URL:</strong> <a href={chatbotOffering.detail_url} target="_blank" rel="noreferrer">{chatbotOffering.detail_url}</a></p>
        <p><strong>Backup Offer Detail:</strong> <span dangerouslySetInnerHTML={{ __html: chatbotOffering.backup_offer_detail }} /></p>
        <p><strong>Terms & Conditions:</strong> <span dangerouslySetInnerHTML={{ __html: chatbotOffering.terms_and_conditions }} /></p>
      </div>

      <div className="flex justify-center gap-3 mt-4">
        <button
          className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700 transition"
          onClick={onDelete}
        >
          Delete
        </button>
      </div>
    </div>
  );
};

export default DeleteChatbotOffering;
